import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface OrderExtraShippingAddressesProps {
  order: SanitizedOrder;
}

const OrderExtraShippingAddresses = ({
  order,
}: OrderExtraShippingAddressesProps) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  if (!entityTotal?.additionalAddressCosts || entityTotal.additionalAddressCosts.quantity === 0) {
    return null;
  }

  return (
    <div className="pd-flex pd-gap-x-4">
      <div className="pd-flex pd-grow pd-flex-col pd-gap-x-4 lg:pd-flex-row">
        <div className="pd-w-full pd-font-bold lg:pd-w-48">
          <FormattedMessage
            id="account.order.additionalAddressCosts.title"
            defaultMessage="Additional address cost"
          />
        </div>
        <div className="pd-grow">
          {entityTotal.additionalAddressCosts.quantity}
        </div>
      </div>
      <div>
        <Money
          value={entityTotal.additionalAddressCosts.basePrice?.totalNet.centAmount ?? 0}
          currency={entityTotal.additionalAddressCosts.basePrice?.totalNet.currencyCode}
        />
      </div>
    </div>
  );
};

export default OrderExtraShippingAddresses;
